var React = require('react');

function SmallMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"fb8w99dkia","d":"M0 0L11.424 0 11.424 1.076 0 1.076z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"transform":"translate(8.788 13.527)","key":0},[React.createElement("mask",{"id":"ic23n3j6kb","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#fb8w99dkia"})),React.createElement("path",{"fill":"#FFF","d":"M6.28 1.076h4.576c.314 0 .568-.24.568-.538 0-.297-.254-.538-.568-.538H.569C.255 0 0 .24 0 .538c0 .297.255.538.569.538H6.28z","mask":"url(#ic23n3j6kb)","key":1})]),React.createElement("ellipse",{"cx":"14.5","cy":"14","stroke":"#FFF","opacity":".5","rx":"14","ry":"13.5","key":1})])]);
}

SmallMinus.defaultProps = {"width":"29","height":"28","viewBox":"0 0 29 28"};

module.exports = SmallMinus;

SmallMinus.default = SmallMinus;
